import { ORGANIZATIONS_EXPAND_DRAWER_QUERY_PARAM } from '@bariendo/lib/constants';

/**
 * The Organizations-page link for a partner, or `undefined` for a reader it would only bounce.
 *
 * That page is gated on the partner-timeline roles: `PartnersPage` shows an access-denied alert
 * and redirects anyone else. Every surface that links a partner passes the reader's access
 * through here and renders nothing rather than a link that fails. `hasPartnerAccess` must be
 * false while permissions are still loading (`usePartnerAccess` does that); `CurrentUserProvider`
 * starts every flag at false, and a link that appears a second late is better than one that
 * appears, then errors.
 */
export function getPartnerDrawerUrl(organizationId: string | undefined, hasPartnerAccess: boolean): string | undefined {
  if (!organizationId || !hasPartnerAccess) {
    return undefined;
  }
  return `/Organizations?${ORGANIZATIONS_EXPAND_DRAWER_QUERY_PARAM}=${organizationId}`;
}
